var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-bold ml-2"},[_vm._v("\n  Edit mode\n  "),_c('toggle-button',{staticClass:"mb-0 ml-2 mr-2",attrs:{"value":_vm.isPPTEditMode,"width":35,"height":20,"color":{
      checked: '#6A1EBB',
      unchecked: '#D3D7E1'
    }},on:{"change":_vm.onChangeEditMode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }